import _ from 'lodash';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const getDefaultState = () => ({
  listAvailable: [],
  selected: null,
  establishmentsIsLoading: true,
});

const initialState = getDefaultState();

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    SET_AVAILABLE_ESTABLISHMENTS(state, establishments) {
      state.listAvailable = establishments;
    },
    SET_SELECTED_ESTABLISHMENT(state, establishment) {
      state.selected = establishment;
    },
    SET_ESTABLISHMENTS_IS_LOADING(state, isLoading) {
      state.establishmentsIsLoading = isLoading;
    },
  },
  actions: {
    async SET_AVAILABLE_ESTABLISHMENTS(store, list) {
      store.commit('SET_AVAILABLE_ESTABLISHMENTS', list);
    },
    async SET_SELECTED_ESTABLISHMENT(store, establishment) {
      store.commit('SET_SELECTED_ESTABLISHMENT', establishment);
    },
    async SET_ESTABLISHMENTS_IS_LOADING(store, isLoading) {
      store.commit('SET_ESTABLISHMENTS_IS_LOADING', isLoading);
    },
  },
  getters: {
    getAvailableEstablishments(state) {
      return _.orderBy(state.listAvailable, 'name');
    },
    getCurrentEstablishment(state) {
      return state.selected;
    },
  },
};
